<template>
    <b-tab title="Checkmend results">
        <div class="row border-bottom pb-2">
            <div v-if="showDetails">
                <dl>
                    <dt>Serial</dt>
                    <dd>{{ selectedGadget.serial }} - {{ selectedGadget.serialdetails.wellformedimei ? "Is well formed" : "Is not well formed" }}</dd>

                    <dt>Find my Iphone</dt>
                    <dd>{{ fmipStatus(selectedGadget.serialdetails.fmipstatus) }}</dd>

                    <dt>Checkmend Status</dt>
                    <dd>{{ selectedGadget.checkmendstatus.result }}</dd>

                    <dt>Blocked</dt>
                    <dd>{{ selectedGadget.blocklist.blocked }}</dd>
                    <p :class="blockedVisible ? null : 'collapsed'"
                       :aria-expanded="blockedVisible ? 'true' : 'false'"
                       aria-controls="collapse-block"
                       @click="blockedVisible = !blockedVisible"
                       style="cursor: pointer;">
                        <b>Block History ({{ selectedGadget.blocklist.history.length }})</b>
                        <i class="ml-2" :class="blockedVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-block" v-model="blockedVisible">
                        <dl class="ml-3" v-if="selectedGadget.blocklist.history.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(block, idx) in selectedGadget.blocklist.history" :key="idx" class="border p-3" style="min-width: 131px;">
                                        <dt>Event Type</dt>
                                        <dd>{{ block.eventtype }}</dd>
                                        <dt>Record Date</dt>
                                        <dd>{{ block.recorddate }}</dd>
                                        <dt>Network</dt>
                                        <dd>{{ block.network }}</dd>
                                        <dt>Reason</dt>
                                        <dd>{{ block.reason ? block.reason : "None found" }}</dd>
                                        <dt>Notes</dt>
                                        <dd>{{ block.notes ? block.notes : "None found" }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="claimsVisible ? null : 'collapsed'"
                       :aria-expanded="claimsVisible ? 'true' : 'false'"
                       aria-controls="collapse-claim"
                       @click="claimsVisible = !claimsVisible"
                       style="cursor: pointer;">
                        <b>Claims ({{ selectedGadget.claims.length }})</b>
                        <i class="ml-2" :class="claimsVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-claim" v-model="claimsVisible">
                        <dl class="ml-3" v-if="selectedGadget.claims.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(claim, idx) in selectedGadget.claims" :key="idx" class="border p-3">
                                        <dt>Identifier</dt>
                                        <dl>{{ claim.identifier }}</dl>
                                        <dt>Claim Date</dt>
                                        <dl>{{ claim.claimdate }}</dl>
                                        <dt>Insurer</dt>
                                        <dl>{{ claim.insurer }}</dl>
                                        <dt>Reference</dt>
                                        <dl>{{ claim.reference }}</dl>
                                        <dt>Make and Model</dt>
                                        <dl>{{ claim.makemodel }}</dl>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="foundVisible ? null : 'collapsed'"
                       :aria-expanded="foundVisible ? 'true' : 'false'"
                       aria-controls="collapse-found"
                       @click="foundVisible = !foundVisible"
                       style="cursor: pointer;">
                        <b>Found ({{ selectedGadget.found.length }})</b>
                        <i class="ml-2" :class="foundVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-found" v-model="foundVisible">
                        <dl class="ml-3" v-if="selectedGadget.found.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(found, idx) in selectedGadget.found" :key="idx" class="border p-3">
                                        <dt>Identifier</dt>
                                        <dd>{{ found.identifier }}</dd>
                                        <dt>Reference</dt>
                                        <dd>{{ found.reference }}</dd>
                                        <dt>Found Date</dt>
                                        <dd>{{ found.founddate }}</dd>
                                        <dt>Location</dt>
                                        <dd>{{ found.location }}</dd>
                                        <dt>Police Force</dt>
                                        <dd>{{ found.policeforce }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="lossVisible ? null : 'collapsed'"
                       :aria-expanded="lossVisible ? 'true' : 'false'"
                       aria-controls="collapse-loss"
                       @click="lossVisible = !lossVisible"
                       style="cursor: pointer;">
                        <b>Found ({{ selectedGadget.loss.length }})</b>
                        <i class="ml-2" :class="lossVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-loss" v-model="lossVisible">
                        <dl class="ml-3" v-if="selectedGadget.loss.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(loss, idx) in selectedGadget.loss" :key="idx" class="border p-3">
                                        <dt>Identifier</dt>
                                        <dd>{{ loss.identifier }}</dd>
                                        <dt>Data Source</dt>
                                        <dd>{{ loss.datasource }}</dd>
                                        <dt>Date Updated</dt>
                                        <dd>{{ loss.dateupdated }}</dd>
                                        <dt>Reference</dt>
                                        <dd>{{ loss.reference }}</dd>
                                        <dt>Police Force</dt>
                                        <dd>{{ loss.policeforce }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="ownershipVisible ? null : 'collapsed'"
                       :aria-expanded="ownershipVisible ? 'true' : 'false'"
                       aria-controls="collapse-ownership"
                       @click="ownershipVisible = !ownershipVisible"
                       style="cursor: pointer;">
                        <b>Ownership ({{ selectedGadget.ownership.length }})</b>
                        <i class="ml-2" :class="ownershipVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-ownership" v-model="ownershipVisible">
                        <dl class="ml-3" v-if="selectedGadget.ownership.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(owner, idx) in selectedGadget.ownership" :key="idx" class="border p-3">
                                        <dt>Data Source</dt>
                                        <dd>{{ owner.datasource }}</dd>
                                        <dt>Date Added</dt>
                                        <dd>{{ owner.dateadded }}</dd>
                                        <dt>Make</dt>
                                        <dd>{{ owner.make }}</dd>
                                        <dt>Model</dt>
                                        <dd>{{ owner.model }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="patriothistoryVisible ? null : 'collapsed'"
                       :aria-expanded="patriothistoryVisible ? 'true' : 'false'"
                       aria-controls="collapse-patriothistory"
                       @click="patriothistoryVisible = !patriothistoryVisible"
                       style="cursor: pointer;">
                        <b>Patriot ({{ selectedGadget.patriothistory.length }})</b>
                        <i class="ml-2" :class="patriothistoryVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-patriothistory" v-model="patriothistoryVisible">
                        <dl class="ml-3" v-if="selectedGadget.patriothistory.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(patriot, idx) in selectedGadget.patriothistory" :key="idx" class="border p-3">
                                        <dt>Insurer</dt>
                                        <dd>{{ patriot.insurer }}</dd>
                                        <dt>Search Date</dt>
                                        <dd>{{ patriot.searchdate }}</dd>
                                        <dt>Contact</dt>
                                        <dd>{{ patriot.contactnumber }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>

                    <p :class="stolenVisible ? null : 'collapsed'"
                       :aria-expanded="stolenVisible ? 'true' : 'false'"
                       aria-controls="collapse-stolen"
                       @click="stolenVisible = !stolenVisible"
                       style="cursor: pointer;">
                        <b>Stolen ({{ selectedGadget.stolen.length }})</b>
                        <i class="ml-2" :class="stolenVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
                    </p>
                    <b-collapse id="collapse-stolen" v-model="stolenVisible">
                        <dl class="ml-3" v-if="selectedGadget.stolen.length > 0">
                            <b-card bg-variant="light">
                                <b-card-body class="d-flex flex-row flex-wrap" style="gap: 10px;">
                                    <div v-for="(stolen, idx) in selectedGadget.stolen" :key="idx" class="border p-3">
                                        <dt>Identifier</dt>
                                        <dd>{{ stolen.identifier }}</dd>
                                        <dt>Data Source</dt>
                                        <dd>{{ stolen.datasource }}</dd>
                                        <dt>Date Updated</dt>
                                        <dd>{{ stolen.dateupdated }}</dd>
                                        <dt>Reference</dt>
                                        <dd>{{ stolen.reference }}</dd>
                                        <dt>Police Force</dt>
                                        <dd>{{ stolen.policeforce }}</dd>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </dl>
                    </b-collapse>
                </dl>
                <button class="btn btn-primary btn-sm" @click="closeCheckmendDetails()">Close Checkmend details</button>
            </div>
        </div>
        <div class="row d-flex p-2" v-if="selectedClaim && selectedClaim.gadgetDetails">
            <b-card :title="gadget.modelLabel" :sub-title="gadget.imeiNo + ' ' + gadget.serialNo" tag="gadget" style="max-width: 20rem;" class="m-2" v-for="(gadget, idx) in selectedClaim.gadgetDetails" :key="idx">
                <template #header>
                    <div class="d-flex">
                        <button class="ml-auto btn btn-primary btn-sm" :disabled="!findGadgetEx(gadget.imeiNo,gadget.serialNo)" @click="showCheckmendDetails(gadget.imeiNo, gadget.serialNo)"><i class="fas fa-external-link-square-alt"></i></button>
                    </div>
                </template>
                <b-card-body v-if="!isLoading">
                    <div class="row" v-if="findGadgetEx(gadget.imeiNo,gadget.serialNo)">
                        <b-list-group flush class="mt-3 mb-3 mx-auto">
                            <b-list-group-item>{{ findGadgetEx(gadget.imeiNo,gadget.serialNo).blocked ? 'Blocked' : 'Not Blocked' }}</b-list-group-item>
                            <b-list-group-item :variant="getStatusColour(findGadgetEx(gadget.imeiNo, gadget.serialNo).checkmendStatusResult)">Status</b-list-group-item>
                            <b-list-group-item>Fmip: {{ fmipStatus(findGadgetEx(gadget.imeiNo,gadget.serialNo).fmipstatus) }}</b-list-group-item>
                            <b-list-group-item>Well formed IMEI: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).wellformedImei }}</b-list-group-item>
                            <b-list-group-item>Model information: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).modelName }}</b-list-group-item>
                            <b-list-group-item>Checked IMEI: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).serial }}</b-list-group-item>
                            <b-list-group-item>Claim Count: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).claimsCount }}</b-list-group-item>
                            <b-list-group-item>Found records: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).foundCount }}</b-list-group-item>
                            <b-list-group-item>Lost records: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).lossCount }}</b-list-group-item>
                            <b-list-group-item>Stolen records: {{ findGadgetEx(gadget.imeiNo,gadget.serialNo).stolenCount }}</b-list-group-item>
                            <b-list-group-item>Last ran: {{ new Date(findGadgetEx(gadget.imeiNo,gadget.serialNo).createdAt).toLocaleString() }}</b-list-group-item>
                        </b-list-group>
                    </div>


                    <p v-else class="row">
                        No search Found
                    </p>
                </b-card-body>
                <b-card-body class="d-flex" v-else>
                    <b-spinner class="mx-auto" label="Loading..."></b-spinner>
                </b-card-body>
                <div class="row">
                    <b-button variant="primary" class="mx-auto align-middle" @click="callCheckmend(gadget)" v-if="showCheckButton(gadget)" :disabled="isLoading">Run checkmend search</b-button>
                </div>
            </b-card>
        </div>
    </b-tab>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data: () => {
        return {
            searchesForClaimGadgets: [],
            isLoading: false,
            showDetails: false,
            selectedGadget: null,
            blockedVisible: false,
            claimsVisible: false,
            foundVisible: false,
            lossVisible: false,
            ownershipVisible: false,
            stolenVisible: false,
            patriothistoryVisible: false
        }
    },
    beforeMount() {
        this.loadGadgetDetails();
        this.getSearchesForClaim(this.selectedClaimId);
    },
    //mounted() {
    //    this.loadGadgetDetails();
    //    this.getSearchesForClaim(this.selectedClaimId);
    //},
    methods: {
        showCheckmendDetails(imei, serial) {
            if (imei != null && imei != '')
                this.selectedGadget = JSON.parse(this.findGadget(imei).responseJson);
            if (serial != null && serial != '')
                this.selectedGadget = JSON.parse(this.findGadget(serial).responseJson);
            this.showDetails = true;
        },
        closeCheckmendDetails() {
            this.showDetails = false;
            this.selectedGadget = null;
        },
        callCheckmend(gadget) {
            // will have to check on a gadget to gadget basis
            // could be muiltple searches against one device

            this.isLoading = true;
            console.log('-g: ', gadget)
            var req = {
                serial: gadget.imeiNo != null && gadget.imeiNo.length > 0 ? gadget.imeiNo : gadget.serialNo,
                gadgetId: gadget.id,
                claimId: this.selectedClaimId
            }
            console.log('-req: ', req)
            this.$store.dispatch('checkmend/gadgetSearch', req).then(r => {
               this.searchesForClaimGadgets.splice(0,0,r);
               this.isLoading = false;
            });
        },
        getSearchesForClaim(claimId) {
            // grab all searches for given claimId
            this.$store.dispatch('checkmend/getSearchesByClaimId', claimId).then(r => {
               this.searchesForClaimGadgets = r;
            });
        },
        getStatusColour(status) {
            var colours = {
                'red': 'danger',
                'amber': 'warning',
                'green': 'success'
            }
            return colours[status];
        },
        fmipStatus(status) {
            var statuses = {
                'notapplicable': 'Not Applicable',
                'notactivated': 'Not Activated',
                'activated': 'Activated',
                'lost': 'Lost'
            }
            return statuses[status];
        },
        findGadgetEx(imei, serial) {
            return this.searchesForClaimGadgets.find(g => g.serial == imei || g.serial == serial);
        },
        findGadget(imei) {
            return this.searchesForClaimGadgets.find(g => g.serial == imei);
        },
        ...mapActions([
            'fetchGadgetsForClaim'
        ]),
        loadGadgetDetails() {
            if (this.selectedClaim) {
                if (!this.selectedClaim.gadgetDetails || this.selectedClaim.gadgetDetails.length == 0) {
                    this.fetchGadgetsForClaim(this.selectedClaimId)
                }
            }
        },
        showCheckButton(gadget) {
            var userHasAccess = this.$adminUser.isClaimAgent() ||
                this.$adminUser.isClaimTeamLeader() ||
                this.$adminUser.isClaimManager() ||
                this.$adminUser.isSystemAdmin()
            return userHasAccess //gadget.imeiNo != null || gadget.serialNo != null
        }
    },
    computed: {
        selectedClaim() {
            return this.$store.getters.selectedClaim
        },
        selectedClaimId() {
            return this.$store.getters.selectedClaim.claimId
        },

    }
}
</script>